import { useEffect, useState } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useBinaryFileExtension = () => {
  const [fileExtension, setFileExtension] = useState<string>("");
  const { handle } = useMessageHandler();

  useEffect(() => {
    handle(async () => {
      const response = await apiJson.get("/binary/fileExtension");
      const text = await response.data; 
      setFileExtension(text);
    });
  }, []);

  return { fileExtension };
};
